export default {
        0: 'Cars',
        1: 'Flights',
        2: 'Hotels',
        3: 'Eurostars',
        4: 'Rails',
        5: 'Seat',
        8: 'EuRails',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/elementsTypesMap.constant.js